require('../../modules/es6.math.sign');
module.exports = require('../../modules/_core').Math.sign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/math/sign.js
// module id = 478
// module chunks = 0